import React from "react";
import FoodSafetyDefenseField from "./FoodSafetyDefenseField";
import FoodDefenseIncidents from "./FoodDefenseIncidents";

import { thisBaseURL } from "../../utils/helper.js";

function FoodSafetyDefense({foodAnswers}){
	let defaultSlug = foodAnswers.answerKeyValues["food_slug"];
	let haccpYear = foodAnswers.answerKeyValues['haccp_year'];
	let haccpSourceRef = foodAnswers.answerKeyValues['haccp_sources'];
	let haccpNotes = foodAnswers.answerKeyValues['haccp_notes'];
	let haccp = foodAnswers.answerKeyValues['haccp'];
	let haccpArr = [];
	if(haccp){
		try {
			haccpArr = JSON.parse(haccp);
		} catch (err) {
			console.log("FoodSafetyDefense :haccp: " +err);
		}
	}
	
	let coatingMixingSourceRef = foodAnswers.answerKeyValues['key_activity_type_coating_mixing_grinding_rework_sources'];
	let coatingMixingYear = foodAnswers.answerKeyValues['key_activity_type_coating_mixing_grinding_rework_year'];
	let coatingMixingNotes = foodAnswers.answerKeyValues['key_activity_type_coating_mixing_grinding_rework_notes'];
	
	let ingredientStagingSourceRef = foodAnswers.answerKeyValues['key_activity_type_ingredient_staging_prep_addition_sources'];
	let ingredientStagingYear = foodAnswers.answerKeyValues['key_activity_type_ingredient_staging_prep_addition_year'];
	let ingredientStagingNotes = foodAnswers.answerKeyValues['key_activity_type_ingredient_staging_prep_addition_notes'];
	
	let liquidReceivingSourceRef = foodAnswers.answerKeyValues['key_activity_type_liquid_receiving_loading_sources'];
	let liquidReceivingYear = foodAnswers.answerKeyValues['key_activity_type_liquid_receiving_loading_year'];
	let liquidReceivingNotes = foodAnswers.answerKeyValues['key_activity_type_liquid_receiving_loading_notes'];
	
	let liquidStorageSourceRef = foodAnswers.answerKeyValues['key_activity_type_liquid_storage_hold_surge_tanks_sources'];
	let liquidStorageYear = foodAnswers.answerKeyValues['key_activity_type_liquid_storage_hold_surge_tanks_year'];
	let liquidStorageNotes = foodAnswers.answerKeyValues['key_activity_type_liquid_storage_hold_surge_tanks_notes'];
	
	let recallHistoryYear =  foodAnswers.answerKeyValues['recall_history_year'];
	let recallHistorySourceRef = foodAnswers.answerKeyValues['recall_history_sources'];
	let recallHistoryNotes = foodAnswers.answerKeyValues['recall_history_notes'];
	
	let foodborneIllnessSourceRef = foodAnswers.answerKeyValues['foodborne_illness_pathogens_sources'];
	let foodborneIllnessYear = foodAnswers.answerKeyValues['foodborne_illness_pathogens_year'];
	let foodborneIllnessNotes = foodAnswers.answerKeyValues['foodborne_illness_pathogens_notes'];
	
	let emaPatternYear =  foodAnswers.answerKeyValues['ema_pattern_year'];
	let emaPatternSourceRef = foodAnswers.answerKeyValues['ema_pattern_sources'];
	let emaPatternText = foodAnswers.answerKeyValues['ema_pattern'];
	
	let emaAdulterantsSourceRef = foodAnswers.answerKeyValues['list_of_past_ema_adulterants_sources'];
	let emaAdulterantsYear = foodAnswers.answerKeyValues['list_of_past_ema_adulterants_year'];
	let emaAdulterantsNotes = foodAnswers.answerKeyValues['list_of_past_ema_adulterants_notes'];
	
	let terrorismSourceRef = foodAnswers.answerKeyValues['terrorism_and_attacks_involving_food_sources'];
	let terrorismYear = foodAnswers.answerKeyValues['terrorism_and_attacks_involving_food_year'];
	let terrorismNotes = foodAnswers.answerKeyValues['terrorism_and_attacks_involving_food_notes'];
	let terrorismText =foodAnswers.answerKeyValues['terrorism_and_attacks_involving_food'];
	
	let currentIssueSourceRef = foodAnswers.answerKeyValues['current_issues_sources'];
	let currentIssueYear = foodAnswers.answerKeyValues['current_issues_year'];
	let currentIssueNotes = foodAnswers.answerKeyValues['current_issues_notes'];
	let currentIssueText =foodAnswers.answerKeyValues['current_issues'];
	
	let emaIncidentsSourceRef = foodAnswers.answerKeyValues['ema_incidents_sources'];
	let emaIncidentsYear = foodAnswers.answerKeyValues['ema_incidents_year'];
	let emaIncidentsNotes = foodAnswers.answerKeyValues['ema_incidents_notes'];
	let emaIncidents = foodAnswers.answerKeyValues['ema_incidents'];
	let emaIncidentArr = [];
	if(emaIncidents){
		try {
			emaIncidentArr = JSON.parse(emaIncidents);
		} catch (err) {
			console.log("FoodSafetyDefense :emaIncidents: " +err);
		}
	}
	
	return (
		<div className="question-grouping" id="food_safety_and_defense">
			<h2>Food Safety and Defense</h2>
			<div className="clearfix" style={{marginBottom: "20px"}}>
				<h3>
					Typical Hazard Analysis and Critical Control Points (HACCP)
					{haccpYear ?
					<small>&nbsp;({haccpYear})</small>
					:""}
					{haccpSourceRef && haccpSourceRef > 0 ? 
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+haccpSourceRef}>{haccpSourceRef}</a></small>
					: ""}
				</h3>
				<table style={{width:"100%", float:"left", marginBottom:"20px"}}>
					<thead>
						<tr>
							<th style={{width:"30%"}}>Hazard</th>
							<th>Common Controls</th>
							<th>Production/Processing Step</th>
						</tr>
					</thead>
					<tbody>
						<FoodSafetyDefenseField haccpArr={{haccpArr}} />
					</tbody>
				</table>
				{haccpNotes  ? 
				<p className="notes-info" style={{marginTop: "auto"}}>
				<em>{haccpNotes}</em>
				</p>
				: ""}
			</div>

			<h3>
				Key Activity Type - Coating/Mixing/Grinding/Rework
				{coatingMixingYear ?
				<small>&nbsp;({coatingMixingYear})</small>
				:""}
				{coatingMixingSourceRef && coatingMixingSourceRef > 0 ? 
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+coatingMixingSourceRef}>{coatingMixingSourceRef}</a></small>
				: ""}
			</h3>
			<p>{foodAnswers.answerKeyValues['key_activity_type_coating_mixing_grinding_rework']}</p>
			{coatingMixingNotes  ? 
			<p className="notes-info" style={{marginTop: "auto"}}>
			<em>{coatingMixingNotes}</em>
			</p>
			: ""}

			<h3>
				Key Activity Type - Ingredient Staging/Prep/Addition
				{ingredientStagingYear ?
				<small>&nbsp;({ingredientStagingYear})</small>
				:""}
				{ingredientStagingSourceRef && ingredientStagingSourceRef > 0 ? 
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+ingredientStagingSourceRef}>{ingredientStagingSourceRef}</a></small>
				: ""}
			</h3>
			<p>{foodAnswers.answerKeyValues['key_activity_type_ingredient_staging_prep_addition']}</p>
			{ingredientStagingNotes  ? 
			<p className="notes-info" style={{marginTop: "auto"}}>
			<em>{ingredientStagingNotes}</em>
			</p>
			: ""}
			
			<h3>
				Key Activity Type - Liquid Receiving/Loading
				{liquidReceivingYear ?
				<small>&nbsp;({liquidReceivingYear})</small>
				:""}
				{liquidReceivingSourceRef && liquidReceivingSourceRef > 0 ? 
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+liquidReceivingSourceRef}>{liquidReceivingSourceRef}</a></small>
				: ""}
			</h3>
			<p>{foodAnswers.answerKeyValues['key_activity_type_liquid_receiving_loading']}</p>
			{liquidReceivingNotes  ? 
			<p className="notes-info" style={{marginTop: "auto"}}>
			<em>{liquidReceivingNotes}</em></p>
			: ""}

			<h3>
				Key Activity Type - Liquid Storage/Hold/Surge Tanks
				{liquidStorageYear ?
				<small>&nbsp;({liquidStorageYear})</small>
				:""}
				{liquidStorageSourceRef && liquidStorageSourceRef > 0 ? 
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+liquidStorageSourceRef}>{liquidStorageSourceRef}</a></small>
				: ""}
			</h3>
			<p>{foodAnswers.answerKeyValues['key_activity_type_liquid_storage_hold_surge_tanks']}</p>
			{liquidStorageNotes && liquidStorageNotes !="" ? 
			<p className="notes-info" style={{marginTop: "auto"}}>
			<em>{liquidStorageNotes}</em></p>
			: ""}

			<h3>
				Recall history
				{recallHistoryYear ? 
				<small>&nbsp;({recallHistoryYear})</small>
				: ""}
				{recallHistorySourceRef && recallHistorySourceRef > 0 ? 
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+recallHistorySourceRef}>{recallHistorySourceRef}</a></small>
				: ""}
			</h3>
			<p>{foodAnswers.answerKeyValues['recall_history']}</p>
			{recallHistoryNotes  ? 
				<p className="notes-info" style={{marginTop: "auto"}}>
				<em>{recallHistoryNotes}</em>
				</p>
			:""}

			<h3>
				Foodborne illness pathogens
				{foodborneIllnessYear ?
				<small>&nbsp;({foodborneIllnessYear})</small>
				:""}
				{foodborneIllnessSourceRef && foodborneIllnessSourceRef > 0 ? 
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+foodborneIllnessSourceRef}>{foodborneIllnessSourceRef}</a></small>
				: ""}
			</h3>
			<p>{foodAnswers.answerKeyValues['foodborne_illness_pathogens']}</p>
			{foodborneIllnessNotes  ? 
			<p className="notes-info" style={{marginTop: "auto"}}>'
			<em>{foodborneIllnessNotes}</em>
			</p>
			: ""}
			
			<h3>
				EMA pattern
				{emaPatternYear ?
				<small>&nbsp;({emaPatternYear})</small>
				:""}
				{emaPatternSourceRef && emaPatternSourceRef > 0?  
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+emaPatternSourceRef}>{emaPatternSourceRef}</a></small>
				: ""}
			</h3>
			<p>{emaPatternText? emaPatternText:""}</p>


			<h3>
				List of past EMA adulterants
				{emaAdulterantsYear ?
				<small>&nbsp;({emaAdulterantsYear})</small>
				:""}
				{emaAdulterantsSourceRef && emaAdulterantsSourceRef > 0? 
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+emaAdulterantsSourceRef}>{emaAdulterantsSourceRef}</a></small>
				: ""}
			</h3>
			<p>{foodAnswers.answerKeyValues['list_of_past_ema_adulterants']}</p>
			{emaAdulterantsNotes ? 
			<p className="notes-info" style={{marginTop: "auto"}}>
			<em>{emaAdulterantsNotes}</em>
			</p>
			: ""}
			
			<h3>
				Terrorism and Attacks Involving Food
				{terrorismYear ?
				<small>&nbsp;({terrorismYear})</small>
				:""}
				{terrorismSourceRef && terrorismSourceRef > 0?  
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+terrorismSourceRef}>{terrorismSourceRef}</a></small>
				: ""}
			</h3>
			<p>{terrorismText? terrorismText:""}</p>
			{terrorismNotes ? 
			<p className="notes-info" style={{marginTop: "auto"}}>
			<em>{terrorismNotes}</em>
			</p>
			: ""}
			
			<h3>
				Current issues
				{currentIssueYear ?
				<small>&nbsp;({currentIssueYear})</small>
				:""}
				{currentIssueSourceRef && currentIssueSourceRef > 0?  
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+currentIssueSourceRef}>{currentIssueSourceRef}</a></small>
				: ""}
			</h3>
			<p>{currentIssueText? currentIssueText:""}</p>
			{currentIssueNotes ? 
			<p className="notes-info" style={{marginTop: "auto"}}>
			<em>{currentIssueNotes}</em>
			</p>
			: ""}
			
			 <h3>
					Food Defense Incidents
					{emaIncidentsYear ? 
					<small>&nbsp;({emaIncidentsYear})</small>
					: ""}
					{emaIncidentsSourceRef && emaIncidentsSourceRef > 0 ? 
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+emaIncidentsSourceRef}>{emaIncidentsSourceRef}</a></small>
					: ""}
				</h3>
				{emaIncidentArr && emaIncidentArr.length >0 ? <table style={{width:"100%", float:"left", marginBottom:"10px"}}>
					<thead></thead>
						<FoodDefenseIncidents emaIncidentArr={{emaIncidentArr}} />
				</table>
				: "" }
				{emaIncidentsNotes ? 
				<p className="notes-info" style={{marginTop:"auto"}} >
					<em>{emaIncidentsNotes}</em>
				</p>
				: ""}
				<p></p>
		</div>
	);
	
}
export default FoodSafetyDefense;